import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';

const initSlider = (el, inBackend) => {
    const hasHero = !!el.querySelector('section.hero');

    let speed = el.dataset.sliderSpeed ?? 500

    let autoplay = {
        enabled: !!el.dataset.sliderAutoplay
    }

    if (inBackend) {
        autoplay = {
            enabled: false
        }
    }

    const options = {
        modules: [Navigation, Pagination, Autoplay],
        speed: speed,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + '</span>';
            }
        },
        navigation: {
            enabled: false,
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: !!el.dataset.sliderLoop,
        autoplay: {
            enabled: false,
            delay: el.dataset.sliderAutoplayDelay ? parseInt(el.dataset.sliderAutoplayDelay) * 1000 : 4000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: hasHero ? 0 : 24,
        breakpoints: {
            480: {
                slidesPerView: hasHero ? 1 : 2,
                slidesPerGroup: 1,
                navigation: {enabled: true}
            },
            768: {
                slidesPerView: hasHero ? 1 : 3,
                slidesPerGroup: 1,
                autoplay: autoplay,
                navigation: {enabled: true}
            },
            992: {
                slidesPerView: hasHero ? 1 : 4,
                slidesPerGroup: 1,
                autoplay: autoplay,
                navigation: {enabled: true}
            }
        },
        on: {
            init: function () {
                // We need a custom method to render all bullets as swiperjs doesn't support this natively
                const totalSlides = this.slides.length;
                this.pagination.el.innerHTML = '';
                for (let i = 0; i < totalSlides; i++) {
                    this.pagination.el.innerHTML += `<span class="swiper-pagination-bullet">${i + 1}</span>`;
                }
                this.pagination.bullets = this.pagination.el.querySelectorAll('.swiper-pagination-bullet');
                this.pagination.update();
                this.pagination.bullets.forEach((bullet, index) => {
                    bullet.addEventListener('click', () => {
                        if (el.dataset.sliderLoop) {
                            this.slideToLoop(index, speed);
                        } else {
                            this.slideTo(index, speed);
                        }
                        // The slideTo functions creates their own logic on what needs to be active
                        // Therefor we reset the active bullet here to make sure it matches the expected behaviour
                        this.pagination.bullets.forEach((bullet) => {
                            bullet.classList.remove('swiper-pagination-bullet-active')
                        });
                        if (this.pagination.bullets[index]) {
                            this.pagination.bullets[index].classList.add('swiper-pagination-bullet-active');
                        }
                    });
                });
            }
        },
        observer: inBackend,
        observeSlideChildren: inBackend
    }

    const slider = new Swiper(el, options)
}

const initializeSliders = () => {
    const sliders = document.querySelectorAll('.slider')
    const inBackend = !!document.querySelector('.neos-backend')

    const checkSliderNavigationStatus = () => {
        sliders.forEach(slider => {
            const lockedButtons = slider.querySelectorAll('.swiper-button-lock')
            if (Array.from(lockedButtons).length === 2) {
                slider.classList.add('navigation--locked')
            } else {
                slider.classList.remove('navigation--locked')
            }
        })
    }

    sliders?.forEach(el => {
        initSlider(el, inBackend);
    })

    checkSliderNavigationStatus()
    window.addEventListener('resize', () => {
        checkSliderNavigationStatus()
    })
}
document.addEventListener("DOMContentLoaded", () => {
    initializeSliders()
})

document.addEventListener('Neos.NodeCreated', e => {
    const nodeType = e.detail.element.dataset.__neosFusionPath.split('/').pop().split('<').pop().replace('>', '')
    if (['App.Site:Content.Slider'].includes(nodeType)) {
        initSlider(e.detail.element, true);
    } else {
        const swiper = e.detail.element.closest('.swiper');
        if (swiper && e.detail.element.parentElement.classList.contains('swiper-slide') && e.detail.element.parentElement.children.length > 1) {
            //swiper.swiper.destroy();
            const referenceSlide = e.detail.element.parentElement;
            const position = e.detail.element.previousSibling ? 'afterend' : 'beforebegin';
            const index = [...e.detail.element.closest('.swiper-wrapper').children].indexOf(referenceSlide) + (position === 'afterend' ? 1 : 0);
            const slide = document.createElement('div');
            swiper.swiper.on('observerUpdate', e => {
                swiper.swiper.slideTo(index);
            })
            slide.classList.add('swiper-slide');
            slide.appendChild(e.detail.element);
            referenceSlide.insertAdjacentElement(position, slide);
            const slider = e.detail.element.closest('.swiper');
            if (slider) {
                const slide = e.detail.element.closest('.swiper-slide');
                slider.swiper.slideTo();
            }
            //initSlider(swiper);
        }
    }
})

document.addEventListener('Neos.NodeSelected', e => {
    const slider = e.detail.element.closest('.swiper');
    if (slider && slider !== e.detail.element) {
        const slide = e.detail.element.closest('.swiper-slide');
        slider.swiper.slideTo(Array.prototype.slice.call(e.detail.element.closest('.swiper-wrapper').children).indexOf(slide));
    }
})
document.addEventListener('Neos.NodeRemoved', e => {
    document.querySelectorAll('.swiper-slide').forEach(slide => {
        if (!slide.childNodes.length) {
            slide.remove();
        }
    });
})
